<div class="modal-content modal-content-right">
  <div class="modal-header">
    <h5 class="modal-title">
      <i class="far fa-user-circle"></i>{{ formTitle }}
    </h5>
    <button type="button" class="close" (click)="close()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="row">
      <div class="col-sm-6">
        <div *ngIf="processor === 'heartland'">
          <app-heartland-card-tokenizer
            #tokenizerForm
            [source]="docSource"
            (tokenData)="onCardTokenReceived($event)"
          >
          </app-heartland-card-tokenizer>
        </div>
        <div *ngIf="processor === 'tsys'">
          <!--      <app-transit-card-tokenizer (tokenData)="onCardTokenReceived($event)"></app-transit-card-tokenizer>-->
        </div>
        <!-- <div class="form-group">
          <span class="text-danger bold">* {{ verifyMessage }} </span>
        </div> -->
      </div>

      <div class="col-sm-6">
        <div class="form-group">
          <div class="custom-control custom-switch">
            <input
              type="checkbox"
              class="custom-control-input"
              name="DefaultCard"
              id="DefaultCard"
              [(ngModel)]="model.IsDefault"
              [ngModelOptions]="{ standalone: true }"
            />
            <label class="custom-control-label" for="DefaultCard"
              >Default Card</label
            >
          </div>
        </div>
        <div class="form-group">
          <label for="carddatasource">Card Data Source</label>
          <select
            id="carddatasource"
            [(ngModel)]="cardDataSource"
            class="form-control"
            [ngModelOptions]="{ standalone: true }"
          >
            <option value="internet" selected="true">Internet</option>
            <option value="phone">Phone</option>
            <option value="mail">Mail</option>
          </select>
        </div>
        <div class="form-group">
          <label for="addressId">Select Address</label>
          <select
            id="addressId"
            [(ngModel)]="addressId"
            class="form-control"
            (change)="addressSelected()"
          >
            <option
              *ngFor="let addr of customerAddressList"
              value="{{ addr.Id }}"
            >
              {{ addr.StreetAddress }} {{ addr.City }} {{ addr.CountryCode }}
              {{ addr.ZipCode }}
            </option>
          </select>
        </div>
        <div class="form-group">
          <button
            type="submit"
            class="btn btn-outline mt-4"
            (click)="addAddress()"
          >
            <i class="fas fa-plus"></i> Add address
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <div class="form-group">
      <span [hidden]="!!tokenizerForm && !tokenizerForm.tokenizerBusy"
        ><i class="fas fa-spinner fa-spin"></i
      ></span>
      <div
        [hidden]="!!tokenizerForm && tokenizerForm.tokenizerBusy"
        id="credit-card-submit"
      ></div>
    </div>
  </div>
</div>
